"use client";

import { useState } from "react";
import { Button, Drawer } from "@wmart/ui";
import { CatalogFilters } from "./CatalogFilters";
import type {
  StorefrontBrandNode,
  StorefrontCategoryNode,
} from "@wmart/shared-types";

interface CatalogFiltersDrawerProps {
  categories: StorefrontCategoryNode[];
  selectedCategorySlugs?: string[];
  brands?: StorefrontBrandNode[];
  selectedBrandSlugs?: string[];
}

export function CatalogFiltersDrawer({
  categories,
  selectedCategorySlugs = [],
  brands = [],
  selectedBrandSlugs = [],
}: CatalogFiltersDrawerProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="secondary"
        size="md"
        icon="filter"
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
        aria-expanded={open}
      >
        Filter
      </Button>
      <Drawer
        open={open}
        onClose={() => setOpen(false)}
        side="left"
        title="Filter"
        width={320}
      >
        <CatalogFilters
          categories={categories}
          brands={brands}
          selectedBrandSlugs={selectedBrandSlugs}
          selectedCategorySlugs={selectedCategorySlugs}
        />
      </Drawer>
    </>
  );
}
